module.exports = __webpack_public_path__ + "static/media/loveable_ai.85515f2f.png";